export const CarrierEnums = {
  USPS: {
    carrierId: '1',
  },
  FedEx: {
    carrierId: '4',
  },
  DhlExpress: {
    carrierId: '5',
  },
  AmazonShipping: {
    carrierId: '80',
  },
  RoyalMail: {
    carrierId: '20',
  },
  FedExWalleted: {
    carrierId: '194',
  },
  ParcelForceRoyalMail: {
    carrierId: '4459',
  },
  RoyalMailClickAndDropWalleted: {
    carrierId: '4421',
  },
};

export const CarrierStatus = {
  Active: 'Active',
  Pending: 'Pending',
};
